import { PluginKey } from '@atlaskit/editor-prosemirror/state';
export const copyButtonPluginKey: PluginKey = new PluginKey('copyButtonPlugin');
